import { observer } from 'mobx-react';
import React, { ReactNode } from 'react';

import { SxProps } from '@mui/material';
import Async from 'components/Async';

import GoBackHeader from './GoBackHeader';
import PageSearchField, { ISearchProps } from './Search';
import Sort, { ISortProps } from './Sort';
import { Body, Header, HeaderTopWrap, Wrapper } from './styled';

export interface IPageListProps extends IPagePropsBasic {
	type: 'list';
	header?: ReactNode;
	sortProps?: ISortProps;
	searchProps?: ISearchProps;
}

interface PropsType extends Omit<IPageListProps, 'type'> {}

interface IPagePropsBasic {
	children: ReactNode;
	title?: string | ReactNode;
	sx?: SxProps;
	isLoading?: boolean;
	onGoBack?: () => void;
}

function PageList({
	title,
	header,
	searchProps,
	sortProps,
	isLoading,
	children,
	onGoBack,
	...props
}: PropsType) {
	const showHeader = title || header || sortProps || searchProps;
	return (
		<Wrapper {...props}>
			{showHeader && (
				<Header>
					<HeaderTopWrap>
						<GoBackHeader title={title} onGoBack={onGoBack} />
						{header}
						{!!sortProps && <Sort {...sortProps} />}
						{!!searchProps && <PageSearchField {...searchProps} />}
					</HeaderTopWrap>
				</Header>
			)}
			<Body>
				<Async loading={isLoading}>{children}</Async>
			</Body>
		</Wrapper>
	);
}

export default observer(PageList);
